'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewTab = NewTab;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NewTab(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-new-tab ' + className, width: width, height: height, viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { fill: color, d: 'M11 13h-8v-8h4.5l2-2h-8.5v12h12v-8.5l-2 2v4.5z' }),
    _react2.default.createElement('path', { fill: color, d: 'M16 0h-6.5l2.5 2.5-7.5 7.5 1.5 1.5 7.5-7.5 2.5 2.5v-6.5z' })
  );
}

NewTab.propTypes = _bcPropTypes.iconShape;

exports.default = NewTab;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/NewTab/NewTab.js
// module id = 269
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15